import { RootState } from "../../../../../redux/store";
import {
  SURVEY_ANSWER_TYPES_ENTITY_TYPE,
  SURVEY_ANSWER_TYPES_LOADING_TYPE,
  SURVEY_ANSWER_SUB_TYPES_ENTITY_TYPE,
  SURVEY_ARTICLES,
  SURVEY_ARTICLES_LOADING,
  SURVEY_ANSWER_SUB_TYPES_LOADING_TYPE,
  SURVEY_DYNAMIC_OPERATORS_ENTITY_TYPE,
  SURVEY_DYNAMIC_OPERATORS_TYPES_LOADING_TYPE,
  SURVEY_VALIDATION_ERRORS,
} from "./constants";

export const isItemsLoading = (state:RootState) => state.surveys.itemsLoading;
export const isItemActionLoading = (state:RootState)  => state.surveys.actionsLoading;
export const getItems = (state:RootState)  => state.surveys.items;
export const getItemsCount = (state:RootState)  => state.surveys.itemsCount;
export const getItemForEdit = (state:RootState)  => {
  return {
    ...state.surveys.itemForEdit,
    ...(state.surveys?.itemForEdit?.version ? {version: String(state.surveys.itemForEdit.version)} : {})
    
  }
};
// export const getNewItemId = (state:RootState) => state.surveys.itemId;
export const getError = (state:RootState) => state.surveys.error;
export const getErrorAction = (state:RootState) => state.surveys.errorAction;

export const getSurveyAnswerTypes = (state:RootState) => state.surveys[SURVEY_ANSWER_TYPES_ENTITY_TYPE];
export const getSurveyAnswerTypesLoading = (state:RootState) => state.surveys[SURVEY_ANSWER_TYPES_LOADING_TYPE];

export const getSurveyAnswerSubTypes = (state:RootState) => state.surveys[SURVEY_ANSWER_SUB_TYPES_ENTITY_TYPE];
export const getSurveyAnswerSubTypesLoading = (state:RootState) => state.surveys[SURVEY_ANSWER_SUB_TYPES_LOADING_TYPE];

export const getSurveyArticlesList = (state:RootState) => state.surveys[SURVEY_ARTICLES];
export const getSurveyArticlesLoading = (state:RootState) => state.surveys[SURVEY_ARTICLES_LOADING]

export const getTaskTypes = (state:RootState) => state.surveys.taskTypes;

export const getSurveyDynamicOperators = (state:RootState) => state.surveys[SURVEY_DYNAMIC_OPERATORS_ENTITY_TYPE];
export const getSurveyDynamicOperatorsLoading = (state:RootState) => state.surveys[SURVEY_DYNAMIC_OPERATORS_TYPES_LOADING_TYPE];

export const getSurveyVersions = (state:RootState) => state.surveys.surveysVersions;

export const validationErrors = (state:RootState) => state.surveys[SURVEY_VALIDATION_ERRORS];
